import React from 'react';
import styled from 'styled-components';
import { spacing } from '../../style/theme';
import { countriesStat } from '../../utils/helpers';
import JumboText from './JumboText';
import ContentContainer from '../ContentContainer';
var ContentContainerPadded = styled(ContentContainer).withConfig({
  displayName: "BottomCTA__ContentContainerPadded",
  componentId: "kq2wjh-0"
})(["margin-top:", "px;margin-bottom:", "px;@media only screen and (max-width:", "px){margin-top:", "px;margin-bottom:", "px;}"], spacing.base * 2, spacing.base * 2, spacing.collapseMenuWidth, spacing.base, spacing.base);
var defaultText = "See why thousands of professionals from " + countriesStat + " countries are using\nPapertrail to capture millions of inspections.";

var BottomCTA = function BottomCTA(_ref) {
  var text = _ref.text,
      className = _ref.className,
      children = _ref.children;
  return React.createElement(ContentContainerPadded, {
    centered: true,
    className: className
  }, React.createElement(JumboText, null, text || defaultText), children && children);
};

export default BottomCTA;